import { FaInstagram, FaFacebook, FaEnvelope } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { useRef } from "react";

export default function Contact() {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_zsgjrpk",
        "template_urdklpj",
        formRef.current,
        "ZARt9Hcb7vPcRUcuT",
      )
      .then(
        () => {
          alert("Message sent successfully 🚀");
          formRef.current.reset();
        },
        (error) => {
          alert("Something went wrong ❌");
          console.error(error);
        }
      );
  };

  return (
    <section
      id="contact"
      className="py-28 bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800"
    >
      <div className="max-w-6xl mx-auto px-6">
        <h3 className="text-3xl font-bold text-center mb-16">
          Let’s Work Together
        </h3>

        <div className="grid md:grid-cols-2 gap-12">
          
          {/* LEFT INFO */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-8 shadow-lg">
            <h4 className="text-xl font-semibold mb-6">
              Contact Information
            </h4>

            <div className="space-y-6 text-gray-700 dark:text-gray-300">
              <a
                href="mailto:ranjitgautam693@gmail.com"
                className="flex items-center gap-4 hover:text-blue-600"
              >
                <FaEnvelope size={22} />
                gautey@duck.com
              </a>

              <a
                href="https://instagram.com/gxrjt_"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-4 hover:text-pink-500"
              >
                <FaInstagram size={22} />
                Instagram
              </a>

              <a
                href="https://facebook.com/ranjit.extra"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-4 hover:text-blue-700"
              >
                <FaFacebook size={22} />
                Facebook
              </a>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-8 shadow-lg">
            <h4 className="text-xl font-semibold mb-6">
              Send a Message
            </h4>

            <form ref={formRef} onSubmit={sendEmail} className="space-y-4">
              <input
                name="name"
                placeholder="Your Name"
                required
                className="w-full border p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
                className="w-full border p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <textarea
                name="message"
                placeholder="Your Message"
                rows="4"
                required
                className="w-full border p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
              >
                Send Message
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}
